<template>
  <div class="container-fluid py-4" :class="{
    'element-wrapper loader-wrapper': !encontrado,
    'element-wrapper': encontrado,
  }">
    <LoaderComponent :condicion="encontrado" />
    <div v-if="encontrado">
      <!-- Header -->
      <div class="row mb-4">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <div class="align-items-center gap-3">
            <button class="btn btn-secondary" @click="regresar">
              Regresar
            </button>
          </div>
          <div class="align-items-center gap-3">
            <center>
              <h1 class="h3 mb-0">Datos de Receta/Combo</h1>
            </center>
          </div>
          <div class="align-items-center gap-3">
            <div class="btn-group">
              <div class="dropleft">
                <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fas fa-cogs"></i> Acciones
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a class="dropdown-item action-hover"
                   data-toggle="modal" data-target="#modalLogsReceta"
                  >
                    <i class="fas fa-history"></i>
                    Ver Historial
                  </a>
                  <a
                    v-if="current.estado === 'A'"
                    class="dropdown-item action-hover"
                    data-toggle="modal" data-target="#modalModificarFechaReceta"
                    @click="abrirModalModificarFecha"
                  >
                    <i class="fas fa-calendar-alt"></i>
                    Modificar Fechas
                  </a>
                  <a
                    v-if="current.estado === 'A'"
                    class="dropdown-item action-hover"
                    @click="solicitarAutorizacion"
                  >
                    <i class="fas fa-box"></i>
                    Solicitar Autorización
                  </a>
                  <a 
                    v-if="current.estado === 'B'"
                    class="dropdown-item action-hover"
                    @click="cerrarReceta"
                  >
                    <i class="fas fa-check"></i>
                    Autorizar y Cerrar
                  </a>
                  <a 
                    v-if="current.estado === 'B'"
                    class="dropdown-item action-hover"
                    @click="reabrir"
                  >
                    <i class="fas fa-box-open"></i>
                    Reabrir
                  </a>
                  <a
                    v-if="current.estado === 'B' || current.estado === 'C'"
                    class="dropdown-item action-hover"
                    data-target="#productoCloneModal"
                    data-toggle="modal"
                    @click="abrirModalDuplicar"
                  >
                    <i class="fas fa-clone"></i>
                    Duplicar Receta
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Form Section -->
      <div class="row mb-4">
        <div class="col-12">
          <div class="card shadow-sm">
            <div class="card-header">
              <h5 class="mb-2">
                {{ current.producto_obj.sku }} - {{ current.producto_obj.nombre }} | Receta # {{ current.numero }}
                <span :class="{
                  'badge bg-success text-white': current.estado === 'A',
                  'badge bg-warning text-black': current.estado === 'B',
                  'badge bg-secondary text-white': current.estado === 'C',
                }">{{ current.estado_obj.descripcion }}</span>
              </h5>
              <span>Disponible del {{ current.fecha_inicio }} al {{ current.fecha_fin }}</span>
            </div>
            <div class="card-body">
              
              <!-- PRECIOS -->
              <div class="row">
                <div class="col-12 mt-4" v-if="current.estado==='A'">
                  <button type="button" data-toggle="modal" @click="abrirModalListaPrecioE()"
                    class="btn btn-sm btn-success btn-lg">
                    <span>
                      Agregar Lista de Precio
                      <i class="bi bi-arrow-right ms-2"></i>
                    </span>
                  </button>
                </div>
                <div class="col-12 mt-4">
                  <div class="table-responsive">
                    <table class="table table-bordered table-sm">
                      <thead>
                        <tr>
                          <th scope="col">Fecha Inicio</th>
                          <th scope="col">Fecha Fin</th>
                          <th scope="col">Lista de Precio</th>
                          <th scope="col">Precio Venta</th>
                          <th scope="col">Descuento</th>
                          <th scope="col">Precio Combo</th>
                          <th scope="col" class="text-center" v-if="current.estado === 'A'">Acciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="current.recetaeprecio_set.length === 0">
                          <td :colspan="current.estado === 'A' ? 7 : 6" class="text-center py-5">
                            <div class="text-muted">
                              <i class="bi bi-inbox fs-1 d-block mb-3 opacity-50"></i>
                              <h5>No hay listas de precio asignadas</h5>
                              <p class="mb-0">Agregue una lista para iniciar</p>
                            </div>
                          </td>
                        </tr>
                        <tr v-for="precioe in current.recetaeprecio_set">
                          <td>{{ precioe.fecha_inicio }}</td>
                          <td>{{ precioe.fecha_fin }}</td>
                          <td v-if="precioe.lista_precio">{{ precioe.lista_precio_obj.nombre }}</td>
                          <td>Q {{ precioe.precio_venta }}</td>
                          <td>% {{ precioe.porcentaje_descuento.toFixed(4) }}</td>
                          <td>Q {{ precioe.precio_combo }}</td>
                          <td class="text-center" v-if="current.estado === 'A'">
                            <button
                              class="btn btn-sm btn-outline-info"
                              title="Editar Fechas"
                              @click="abrirModalEditarFechaListaPrecio(precioe)"
                            >
                              <i class="fas fa-calendar-alt"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div v-if="resumenTrazabilidad.length > 0" class="mb-3">
                <small class="text-muted font-weight-bold d-block mb-1">Historial de solicitudes:</small>
                <ul class="list-unstyled pl-2 mb-0">
                  <li v-for="(item, index) in resumenTrazabilidad" :key="index" class="mb-1">
                    <small class="d-block">
                      <i class="fas fa-circle text-primary mr-1" style="font-size: 0.5rem; vertical-align: middle;"></i>
                      <span class="text-capitalize font-weight-bold">{{ item.accion }} </span>
                      <strong>{{ item.username }}</strong> 
                      <span class="text-muted">: {{ item.fecha_creacion }}</span>
                    </small>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <ul class="nav nav-tabs" id="recetaTabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="detalle-tab" data-toggle="tab" href="#detalleIngredientes" role="tab"
              aria-controls="detalleIngredientes" aria-selected="true">
              Ingredientes
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="inventario-tab" data-toggle="tab" href="#inventarioTienda" role="tab"
              aria-controls="inventarioTienda" aria-selected="false">
              Inventario por Tienda
            </a>
          </li>
        </ul>
        <div class="tab-content" id="recetaTabContent">
          <div class="tab-pane fade show active" id="detalleIngredientes" role="tabpanel" aria-labelledby="detalle-tab">
            <div class="card-body">
              <!-- Scanner Section -->
              <div class="row mb-4" v-if="current.estado === 'A'">
                <div class="col-12">
                  <div class="card shadow-sm">
                    <div class="card-header">
                      <h5 class="mb-0">Escanear Ingredientes</h5>
                    </div>
                    <div class="card-body">
                      <!-- Scanner de Producto Principal -->
                      <SearchProductoComponent v-model="productoSeleccionado" @error="manejarError"
                        ref="scannerInput" />
                      <!-- Producto Encontrado -->
                      <div v-if="productoSeleccionado" class="mb-4">
                        <div class="alert alert-success d-flex justify-content-between align-items-center">
                          <div>
                            <i class="bi bi-check-circle me-2"></i>
                            <strong>Producto encontrado:</strong>
                            <div class="mt-2">
                              <div class="fw-bold">{{ productoSeleccionado.nombre }}</div>
                              <small class="text-muted">SKU: {{ productoSeleccionado.sku }}</small>
                            </div>
                          </div>
                          <button class="btn btn-sm btn-outline-danger" @click="limpiarProducto"
                            title="Cambiar producto">
                            <i class="fas fa-trash"></i>
                          </button>
                        </div>
                        <span v-if="errors && errors.producto" class="text-danger">{{ errors.producto }}</span>
                      </div>
                      <!-- Mensaje de error -->
                      <div v-if="errorBusqueda" class="alert alert-danger">
                        <i class="bi bi-exclamation-triangle me-2"></i>
                        {{ errorBusqueda }}
                      </div>
                      <div v-if="productoSeleccionado">
                        <h6 class="mb-0">Ingrese Detalles</h6>
                        <div class="mb-3">
                          <label class="form-label fw-semibold">
                            Cantidad <span class="text-danger">*</span>
                          </label>
                          <input onkeyup="if(this.value<0){this.value= this.value * -1}" type="number"
                            class="form-control" v-model="detalle.cantidad_um" min="0.01" step="0.01"
                            placeholder="0.00" />
                          <span v-if="errors && errors.cantidad_um" class="text-danger">{{ errors.cantidad_um }}</span>
                        </div>
                        <div class="mb-3">
                          <label class="form-label fw-semibold">
                            Unidad de Medida <span class="text-danger">*</span>
                          </label>
                          <select class="form-control" v-model="detalle.unidad_medida">
                            <option value="" disabled selected>Seleccione una unidad de medida</option>
                            <option
                              v-for="producto_unidad in productoSeleccionado.productounidadmedida_set" 
                              :value="producto_unidad.unidad_medida.id">{{ producto_unidad.unidad_medida.nombre }}</option>
                          </select>
                          <span class="text-danger" v-if="errors && errors.unidad_medida">{{ errors.unidad_medida }}</span>
                        </div>
                        

                        <!-- Botón Guardar -->
                        <div class="d-grid gap-2">
                          <button class="btn btn-success btn-lg" @click="agregarDetalle" :disabled="guardando">
                            <span v-if="guardando">
                              <span class="spinner-border spinner-border-sm me-2"></span>
                              Guardando...
                            </span>
                            <span v-else>
                              Guardar y Continuar
                              <i class="bi bi-arrow-right ms-2"></i>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Detalles -->
              <div class="row">
                <div class="col-12">
                  <div class="card shadow-sm">
                    <div class="card-header d-flex justify-content-between align-items-center">
                      <h5 class="mb-0">Detalle de Ingredientes</h5>
                      <span class="badge bg-info">{{ detallesReceta.length }} items</span>
                    </div>
                    <div class="card-body p-0">
                      <div class="row mb-2 align-items-center">
                        <div class="col-9 m-2">
                          Buscar por: <input class="form-control" type="text" v-model="buscarDetalles" placeholder="Escribir sku, nombre del producto">
                        </div>
                        <div class="col-2 p-2" v-if="current.estado==='A'">
                          <center>
                            <button type="button" data-toggle="modal" @click="abrirModalListaPrecioD()"
                              class="btn btn-sm btn-success">
                              <span>
                                Agregar/Asignar Precios
                              </span>
                            </button>
                          </center>
                        </div>
                      </div>
                      <div class="table-responsive tableFixHead">
                      <table class="table table-bordered table-striped mb-0">
                        <thead>
                          <!-- FILA 1: Grupos de columnas -->
                          <tr>
                            <th class="text-center" colspan="4">Datos Ingrediente</th>
                            <th 
                              v-for="precios in current.recetaeprecio_set" 
                              :key="'grupo-' + precios.lista_precio"
                              class="text-center" 
                              colspan="4"
                              style="width: 450px;"
                            >
                              {{ precios.lista_precio_obj.nombre }}
                            </th>
                            <th colspan="3" class="text-center" v-if="current.estado === 'A'"></th>
                          </tr>

                          <!-- FILA 2: Sub-columnas -->
                          <tr>
                            <!-- <th style="width: 50px;" class="text-center">#</th> -->
                            <th style="width: 120px;">SKU</th>
                            <th>Producto</th>
                            <th style="width: 120px;" class="text-center">Cant.</th>
                            <th style="width: 150px;">Unidad Medida</th>
                            <th
                              v-for="col in columnasPrecios"
                              :key="'header-' + col.tipo + '-' + col.lista_precio"
                              style="width: 150px;"
                            >
                              <span v-if="col.tipo === 'venta'">Precio Venta</span>
                              <span v-if="col.tipo === 'descuento'">Descuento</span>
                              <span v-if="col.tipo === 'combo'">Precio Combo</span>
                              <span v-if="col.tipo === 'subtotal'">Subtotal Combo</span>
                            </th>
                            <th colspan="3" class="text-center" v-if="current.estado === 'A'">Acciones</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr v-if="detallesReceta.length === 0">
                            <td :colspan="5 + (current.recetaeprecio_set.length * 4)" class="text-center py-5">
                              <div class="text-muted">
                                <i class="bi bi-inbox fs-1 d-block mb-3 opacity-50"></i>
                                <h5>No hay ingredientes agregados</h5>
                                <p class="mb-0">Escanee un código de barras para comenzar</p>
                              </div>
                            </td>
                          </tr>

                          <tr v-for="(detalle, index) in detallesRecetaFiltrada" :key="index">
                            <!-- <td class="text-center align-middle fw-bold">{{ index + 1}}</td> -->
                            <td class="align-middle">
                              <div class="fw-semibold text-dark">{{ detalle.producto_obj.sku }}</div>
                            </td>
                            <td class="align-middle">
                              <div class="fw-semibold text-dark">{{ detalle.producto_obj.nombre }}</div>
                            </td>
                            <td class="align-middle text-center">
                              <input
                                v-if="indiceEditando === index"
                                type="number"
                                v-model.number="cantidadTemporal"
                                class="form-control form-control-sm text-center"
                                @keyup.enter="guardarCantidad(detalle)"
                                style="width: 75px; display: inline-block;"
                                min="0.01"
                              >
                              <span v-else class="fw-semibold text-dark">{{ detalle.cantidad_um }}</span>
                            </td>
                            <td class="align-middle">
                              <div class="fw-semibold text-dark">{{ detalle.unidad_medida_obj.nombre }}</div>
                            </td>

                            <td
                              v-for="col in columnasPrecios"
                              :key="'col-' + col.tipo + '-' + col.lista_precio + '-' + index"
                              :class="{
                                'text-right align-middle bg-warning':col.tipo==='subtotal',
                                'text-right align-middle':col.tipo!=='subtotal'
                              }"
                            >
                              <span v-if="col.tipo === 'venta'">{{ precioVenta(detalle, col.lista_precio) }}</span>
                              <span v-if="col.tipo === 'descuento'">{{ porcentajeDescuento(detalle, col.lista_precio) }}</span>
                              <span v-if="col.tipo === 'combo'">{{ precioCombo(detalle, col.lista_precio) }}</span>
                              <span v-if="col.tipo === 'subtotal'">{{ precioSubtotal(detalle, col.lista_precio) }}</span>
                            </td>

                            <td class="text-center align-middle" v-if="current.estado === 'A'">
                              <div>
                                <button 
                                  v-if="indiceEditando === index"
                                  class="btn btn-sm btn-outline-success"
                                  title="Guardar"
                                  @click="guardarCantidad(detalle)"
                                >
                                  <i class="fas fa-save"></i>
                                </button>
                                <button 
                                  v-else
                                  class="btn btn-sm btn-outline-warning"
                                  title="Editar"
                                  @click="iniciarEdicion(index, detalle)"
                                >
                                  <i class="fas fa-pen"></i>
                                </button>
                              </div>
                            </td>
                            <td class="text-center align-middle" v-if="current.estado === 'A'">
                              <button  
                                class="btn btn-sm btn-outline-success" 
                                @click="abrirModalListaPrecioD(detalle)"
                                title="Precio"
                              >
                                <i class="fas fa-money-bill"></i>
                              </button>
                            </td>
                            <td class="text-center align-middle" v-if="current.estado === 'A'">
                              <button 
                                class="btn btn-sm btn-outline-danger" 
                                @click="quitarDetalle(detalle)"
                                title="Eliminar"
                              >
                                <i class="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane fade" id="inventarioTienda" role="tabpanel" aria-labelledby="inventario-tab">
            <div class="card-body">
              <h5 class="mb-3">Existencias:</h5>
              <!-- Botón Guardar -->
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-grid gap-2 mb-3">
                  <button type="button" data-toggle="modal" data-target="#movimientoInventarioModal"
                    class="btn btn-sm btn-success btn-lg">
                    <span>
                      Agregar inventario
                      <i class="bi bi-arrow-right ms-2"></i>
                    </span>
                  </button>
                </div>
                <div class="d-grid gap-2 mb-3">
                  <button type="button" data-toggle="modal" data-target="#movimientoInventario2Modal"
                    class="btn btn-sm btn-danger btn-lg">
                    <span>
                      Quitar Inventario
                      <i class="bi bi-arrow-right ms-2"></i>
                    </span>
                  </button>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Tienda</th>
                      <th scope="col">Cantidad Fabricada (+)</th>
                      <th scope="col">Cantidad Desmantelada (-)</th>
                      <th scope="col">Cantidad Vendida (-)</th>
                      <th scope="col">Cantidad Devuelta (+)</th>
                      <th scope="col">Existencia</th>
                      <th scope="col">Recetario</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="current.recetatienda_set.length === 0">
                      <td colspan="7" class="text-center py-5">
                        <div class="text-muted">
                          <i class="bi bi-inbox fs-1 d-block mb-3 opacity-50"></i>
                          <h5>No hay tiendas con existencias</h5>
                          <p class="mb-0">Agregue una tienda para iniciar</p>
                        </div>
                      </td>
                    </tr>
                    <tr v-for="recetatienda in current.recetatienda_set">
                      <td>{{ recetatienda.tienda_obj.codigo }}-{{ recetatienda.tienda_obj.nombre }}</td>
                      <td>{{ recetatienda.cantidad_fabricada }}</td>
                      <td>{{ recetatienda.cantidad_desmantelada }}</td>
                      <td>{{ recetatienda.cantidad_vendida }}</td>
                      <td>{{ recetatienda.cantidad_devuelta }}</td>
                      <td>{{ recetatienda.existencia_calculada }}</td>
                      <td class="text-center">
                        <button
                          class="btn btn-sm btn-outline-secondary"
                          title="Editar Fechas"
                          @click="imprimirRecetario(recetatienda.tienda_obj.lista_precio)"
                        >
                          <i class="fas fa-print"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- AGREGAR LISTA PRECIO RECETA -->
      <div class="modal fade" id="agregarListaPrecioEModal" tabindex="-1" role="dialog"
        aria-labelledby="movimientoInventarioLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="movimientoInventarioLabel">Agregar Lista de Precio</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              
              <div class="form-group">
                <ListasPrecioSelectComponent
                  titulo="Lista de Precio para Recetas"
                  :current="lista_precio_e"
                />
              </div>

              <div class="form-group">
                <label for="inputFechaInicio">Fecha de Inicio:</label>
                <input 
                  type="date" 
                  class="form-control" 
                  id="inputFechaInicio"
                  v-model="lista_precio_e.fecha_inicio"
                  :max="fin"
                  :min="minFechaInicio"
                  @change="validarFechas"
                >
              </div>

              <div class="form-group">
                <label for="inputFechaFin">Fecha de Fin:</label>
                <input 
                  type="date" 
                  class="form-control" 
                  id="inputFechaFin"
                  v-model="lista_precio_e.fecha_fin"
                  :max="fin"
                  :min="minFechaFin"
                  @change="validarFechas"
                >
              </div>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Debe llenar todos los campos para continuar.
              </small><br>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Las fechas de la lista precio pueden ser personalizables pero en el rango que inicia el {{ current.fecha_inicio }} al {{ current.fecha_fin }}.
              </small>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>

              <button v-if="lista_precio_e.lista_precio && lista_precio_e.fecha_inicio && lista_precio_e.fecha_fin" type="button" class="btn btn-success" @click="agregarListaPrecioE()">
                Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN -->
      <!-- MODIFICAR FECHAS DE RECETA -->
      <div class="modal fade" id="modalModificarFechaReceta" tabindex="-1" role="dialog"
        aria-labelledby="modalModificarFechaRecetaLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalModificarFechaRecetaLabel">Modificar Fechas de Vigencia</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label for="inputFechaInicioReceta">Fecha de Inicio:</label>
                <input
                  type="date"
                  class="form-control"
                  id="inputFechaInicioReceta"
                  v-model="modificarFecha.fecha_inicio"
                  :min="diaSiguiente"
                  @change="validarFechasModificar"
                >
              </div>

              <div class="form-group">
                <label for="inputFechaFinReceta">Fecha de Fin:</label>
                <input
                  type="date"
                  class="form-control"
                  id="inputFechaFinReceta"
                  v-model="modificarFecha.fecha_fin"
                  :min="minFechaFinModificar"
                  @change="validarFechasModificar"
                >
              </div>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                La fecha de inicio debe ser del día siguiente a hoy en adelante y la fecha fin igual o mayor a la fecha de inicio.
              </small>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>

              <button v-if="modificarFecha.fecha_inicio && modificarFecha.fecha_fin" type="button" class="btn btn-success" @click="guardarModificarFecha()">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN -->
      <!-- EDITAR FECHA DE LISTA PRECIO RECETA -->
      <div class="modal fade" id="editarFechaListaPrecioModal" tabindex="-1" role="dialog"
        aria-labelledby="editarFechaListaPrecioLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editarFechaListaPrecioLabel">Editar Fechas de Lista de Precio</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label>Lista de Precio:</label>
                <input type="text" class="form-control" :value="editarListaPrecioE.nombre" disabled>
              </div>

              <div class="form-group">
                <label for="inputFechaInicioEditarListaPrecio">Fecha de Inicio:</label>
                <input
                  type="date"
                  class="form-control"
                  id="inputFechaInicioEditarListaPrecio"
                  v-model="editarListaPrecioE.fecha_inicio"
                  :max="fin"
                  :min="minFechaInicio"
                  @change="validarFechasEditarListaPrecio"
                >
              </div>

              <div class="form-group">
                <label for="inputFechaFinEditarListaPrecio">Fecha de Fin:</label>
                <input
                  type="date"
                  class="form-control"
                  id="inputFechaFinEditarListaPrecio"
                  v-model="editarListaPrecioE.fecha_fin"
                  :max="fin"
                  :min="minFechaFinEditarListaPrecio"
                  @change="validarFechasEditarListaPrecio"
                >
              </div>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Las fechas de la lista precio deben estar en el rango que inicia el {{ current.fecha_inicio }} al {{ current.fecha_fin }}.
              </small>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>

              <button v-if="editarListaPrecioE.fecha_inicio && editarListaPrecioE.fecha_fin" type="button" class="btn btn-success" @click="guardarEditarFechaListaPrecio()">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN -->
       <!-- AGREGAR LISTA PRECIO INGREDIENTES -->
      <div class="modal fade" id="agregarListaPrecioDModal" tabindex="-1" role="dialog"
        aria-labelledby="movimientoInventarioLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="movimientoInventarioLabel">Agregar Precio A Ingrediente</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label for="inputFechaInicio">Ingrediente:</label>
                <select class="form-control" v-model="lista_precio_d.ingrediente">
                  <option v-for="detalle in current.recetad_set" :value="detalle">{{ detalle.producto_obj.sku }}-{{ detalle.producto_obj.nombre }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="inputFechaInicio">Lista Precio:</label>
                <select class="form-control" v-model="lista_precio_d.lista_precio">
                  <option v-for="detalle in current.recetaeprecio_set" :value="detalle.lista_precio">{{ detalle.lista_precio_obj.nombre }}</option>
                </select>
              </div>
              
              <div class="form-group">
                <label for="inputFechaFin">Precio Venta:</label>
                <input 
                  type="number" 
                  class="form-control" 
                  :value="sugeridoVenta"
                  disabled
                >
              </div>
              <div class="form-group">
                <label for="inputFechaFin">Precio en el Combo:</label>
                <input 
                  type="number" 
                  class="form-control" 
                  v-model="lista_precio_d.precio_combo"
                  onkeyup="if(this.value<0){this.value= this.value * -1}"
                  placeholder="0.00"
                  min="0.00"
                >
              </div>
              <div class="form-group" v-if="lista_precio_d.precio_combo === 0">
                <label for="inputFechaFin">¿Confirmar precio a valor 0?</label>
                <input 
                  type="checkbox" 
                  class="form-control m-2" 
                  v-model="lista_precio_d.precio_cero"
                >
              </div>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Debe llenar todos los campos para continuar.
              </small><br>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Revisar siempre el precio, ya que sí puede ir a 0 como productos bonificados.
              </small><br>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Si el registro de ingrediente y lista precio ya existe, este solo actualizará el precio colocado.
              </small><br>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Las listas de precio son únicamente las que ya fueron agregadas al producto Combo.
              </small>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>

              <button v-if="lista_precio_d.lista_precio && lista_precio_d.ingrediente && (lista_precio_d.precio_combo >0 || (lista_precio_d.precio_combo===0 && lista_precio_d.precio_cero))" 
                type="button" class="btn btn-success" @click="agregarListaPrecioD()"
              >
                Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN -->
      <!-- AGREGAR INVENTARIO -->
      <div class="modal fade" id="movimientoInventarioModal" tabindex="-1" role="dialog"
        aria-labelledby="movimientoInventarioLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="movimientoInventarioLabel">Agregar Cantidad a Inventario</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label for="selectTienda">Selecciona la Tienda:</label>
                <select class="form-control" id="selectTienda" v-model="inventario.tienda">
                  <option value="" disabled selected>--- Selecciona una tienda ---</option>
                  <option v-for="tienda in current.tiendas_por_lista" :value="tienda.codigo">{{ tienda.codigo }}-{{ tienda.nombre }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="inputCantidad">Cantidad a Fabricar:</label>
                <input type="number" class="form-control" id="inputCantidad" placeholder="Escribe la cantidad" min="1"
                  v-model="inventario.cantidad_fabricada">
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>

              <button type="button" class="btn btn-success" @click="agregarInventario">
                Agregar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN -->
      <!-- DESMANTELAR -->
      <div class="modal fade" id="movimientoInventario2Modal" tabindex="-1" role="dialog"
        aria-labelledby="movimientoInventario2Label" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="movimientoInventario2Label">Desmantelar Inventario</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="form-group">
                <label for="selectTienda">Selecciona la Tienda:</label>
                <select class="form-control" id="selectTienda" v-model="inventario.tienda">
                  <option value="" disabled selected>--- Selecciona una tienda ---</option>
                  <option v-for="tienda in current.tiendas_por_lista" :value="tienda.codigo">{{ tienda.codigo }}-{{ tienda.nombre }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="inputCantidad">Cantidad a Desmantelar:</label>
                <input type="number" class="form-control" id="inputCantidad" placeholder="Escribe la cantidad" min="1"
                  v-model="inventario.cantidad_desmantelada">
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>

              <button type="button" class="btn btn-danger" @click="quitarInventario">
                Quitar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- CLONADO -->
      <div class="modal fade" id="productoCloneModal" tabindex="-1" role="dialog"
        aria-labelledby="productoCloneLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="productoCloneLabel">Duplicar Receta</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>

            </div>

            <div class="modal-body">
              <div class="mb-4">
                <div class="alert alert-success d-flex justify-content-between align-items-center">
                  <div>
                    <i class="bi bi-check-circle me-2"></i>
                    <strong>Se duplicará sobre el mismo producto:</strong>
                    <div class="mt-2">
                      <div class="fw-bold">{{ current.producto_obj.nombre }}</div>
                      <small class="text-muted">SKU: {{ current.producto_obj.sku }}</small>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label for="inputFechaInicioDuplicar">Fecha de Inicio:</label>
                <input
                  type="date"
                  class="form-control"
                  id="inputFechaInicioDuplicar"
                  v-model="duplicarReceta.fecha_inicio"
                  :min="diaSiguiente"
                  @change="validarFechasDuplicar"
                >
              </div>

              <div class="form-group">
                <label for="inputFechaFinDuplicar">Fecha de Fin:</label>
                <input
                  type="date"
                  class="form-control"
                  id="inputFechaFinDuplicar"
                  v-model="duplicarReceta.fecha_fin"
                  :min="minFechaFinDuplicar"
                  @change="validarFechasDuplicar"
                >
              </div>
              <small>
                <i class="fas fa-info-circle mr-1"></i>
                Se copiarán los ingredientes tal cual están en esta receta. Las listas de precio deberán agregarse nuevamente en la receta duplicada.
              </small>
            </div>
            <div class="alert alert-warning" v-if="computedMessage">
              <transition name="message-slide" mode="out-in">
                <small
                  :key="computedMessage"
                  class="status-message"
                >
                  {{ computedMessage }}
                </small>
              </transition>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>
              <button
                v-if="duplicarReceta.fecha_inicio && duplicarReceta.fecha_fin"
                type="button" class="btn btn-success"
                @click="guardarDuplicar"
              >
                Duplicar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- EDITAR DETALLE -->
      <div class="modal fade" id="editDetalleModal" tabindex="-1" role="dialog"
        aria-labelledby="editDetalleLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editDetalleLabel">Duplicar Receta</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Cerrar">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                Cancelar
              </button>
              <button type="button" class="btn btn-success"
                @click="guardarDuplicar"
              >
                Duplicar
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- LOGS DE RECETA -->
      <div class="modal fade" id="modalLogsReceta" tabindex="-1" role="dialog" aria-labelledby="modalLogsLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
          <div class="modal-content">
            
            <!-- Encabezado -->
            <div class="modal-header">
              <h5 class="modal-title" id="modalLogsLabel">Historial de Logs de Receta</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <!-- Cuerpo del Modal -->
            <div class="modal-body p-3">

              <!-- BARRA DE FILTROS (Solo si existen logs originales) -->
              <div class="row mb-3" v-if="current && current.recetalog_set && current.recetalog_set.length > 0">
                <!-- Buscador por Usuario o Acción -->
                <div class="col-md-8 mb-2 mb-md-0">
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-search"></i></span>
                    </div>
                    <input 
                      type="text" 
                      class="form-control" 
                      placeholder="Buscar por usuario o acción..." 
                      v-model="searchQuery"
                    >
                    <div class="input-group-append" v-if="searchQuery">
                      <button class="btn btn-outline-secondary" type="button" @click="searchQuery = ''">
                        &times;
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Selector de Tipo -->
                <div class="col-md-4">
                  <div class="input-group input-group-sm">
                    <div class="input-group-prepend">
                      <label class="input-group-text" for="selectTipo">Tipo</label>
                    </div>
                    <select class="custom-select" id="selectTipo" v-model="selectedTipo">
                      <option value="">Todos los tipos</option>
                      <option v-for="tipo in tiposDisponibles" :key="tipo" :value="tipo">
                        {{ tipo }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              
              <!-- CONTENEDOR CON SCROLL Y TABLA -->
              <div 
                v-if="logsFiltrados.length > 0" 
                style="overflow-x: auto; overflow-y: auto; max-height: 65vh;"
              >
                <table class="table table-striped table-hover table-bordered table-sm m-0" style="min-width: 1200px; width: 100%;">
                  <thead class="thead-dark" style="position: sticky; top: 0; z-index: 1;">
                    <tr>
                      <th style="width: 140px;">Fecha Creación</th>
                      <th style="width: 130px;">Usuario</th>
                      <th style="width: 250px;">Datos</th>
                      <th style="width: 90px;">Método</th>
                      <th style="width: 250px;">Mensaje</th>
                      <th style="width: 90px;">Tipo</th>
                      <th style="width: 110px;">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Se itera sobre la propiedad computada logsFiltrados -->
                    <tr v-for="(log, index) in logsFiltrados" :key="log.id || index">
                      <td class="align-middle text-nowrap"><small>{{ obtenerFechaHora(log.fecha_creacion)}}</small></td>
                      <td class="align-middle"><small>{{ log.usuario_username }}</small></td>
                      <td class="align-middle">
                        <small style="word-break: break-all;">{{ log.datos }}</small>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge badge-info">{{ log.metodo }}</span>
                      </td>
                      <td class="align-middle">
                        <small style="word-break: break-word;">{{ log.mensaje }}</small>
                      </td>
                      <td class="align-middle text-center">
                        <span :class="{
                          'badge badge-success': log.tipo === 'EXITO',
                          'badge badge-info': log.tipo === 'INFO',
                          'badge badge-danger': log.tipo === 'ERROR'
                          }"
                        >{{ log.tipo }}</span>
                      </td>
                      <td class="align-middle text-center">
                        <span class="badge badge-primary">{{ log.accion }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Alerta cuando el filtro no coincide con nada -->
              <div class="alert alert-info text-center my-3" role="alert" v-else-if="current && current.recetalog_set && current.recetalog_set.length > 0">
                <i class="fas fa-info-circle mr-2"></i> No se encontraron resultados que coincidan con los filtros aplicados.
              </div>

              <!-- Alerta de "No hay datos en la receta" -->
              <div class="alert alert-warning text-center my-3" role="alert" v-else>
                <i class="fas fa-exclamation-triangle mr-2"></i> No se encontraron logs registrados para esta receta.
              </div>

            </div>

            <!-- Pie del Modal -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Cerrar</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RecetaService from "@/services/catalogos/RecetaService";
import LoaderComponent from "@/components/commons/LoaderComponent";
import SearchProductoComponent from "@/components/commons/SearchProductoComponent";
import ListasPrecioSelectComponent from "@/components/commons/ListasPrecioSelectComponent"
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

import { parsearFechaHoraString,formatToISO,notificarExito,notificarAdvertencia,notificarError } from "@/utils";

export default {
  components: {
    LoaderComponent, SearchProductoComponent,ListasPrecioSelectComponent
  },

  data() {
    return {
      currentStatus:'',
      current: null,
      detallesReceta: [],
      encontrado: false,
      productoSeleccionado: null,
      mensajeClonando:'',
      errors: null,
      guardando: false,
      errorBusqueda: '',
      buscarDetalles:'',
      indiceEditando: null,
      cantidadTemporal: null,
      inventario: {
        tienda: '',
        cantidad_fabricada: 0,
        cantidad_desmantelada: 0,
        receta: '',
      },
      detalle: {
        producto: '',
        receta: '',
        cantidad_um: 1,
        unidad_medida: "",
      },
      receta: {
        producto: null,
      },
      detalles: [],
      codigoBarras: '',
      lista_precio_d: {
        ingrediente:null,
        lista_precio:null,
        precio_combo:0.00,
        precio_cero:false
      },
      lista_precio_e: {
        lista_precio:null,
        fecha_inicio:null,
        fecha_fin:null
      },
      modificarFecha: {
        fecha_inicio:null,
        fecha_fin:null
      },
      editarListaPrecioE: {
        id:null,
        nombre:'',
        fecha_inicio:null,
        fecha_fin:null
      },
      duplicarReceta: {
        fecha_inicio:null,
        fecha_fin:null
      },
      searchQuery: '',
      selectedTipo: '',
      motivoReapertura:'',
    };
  },
  watch: {
    '$route.params.id'(newValue) {
      if (newValue) {
        this.encontrado = false;
        this.refreshCurrent();
      }
    },
    productoSeleccionado(newValue) {
      if (newValue != null) {
        if(!newValue.activo){
          notificarAdvertencia(this.$toast,"El producto seleccionado no está activo.");
          this.limpiarProducto();
        }
        if(newValue.sku === this.current.producto){
          notificarAdvertencia(this.$toast,"El producto escaneado no puede ser el mismo al producto de receta.");
          this.limpiarProducto();
        }
        
      }
    },
    'detalle.cantidad_um'(newValue, oldValue) {
      // Reacciona solo si el nuevo valor no es null
      if (newValue != null || newValue !== "") {
        if (newValue < 0) this.detalle.cantidad_um = newValue* -1
      }
    },
    'lista_precio_d.precio_combo'(newValue, oldValue) {
      // Reacciona solo si el nuevo valor no es null
      if (newValue != null || newValue !== "") {
        if (newValue < 0) this.lista_precio_d.precio_combo = parseFloat(newValue* -1);
        if (newValue === "0") this.lista_precio_d.precio_combo = parseFloat(0);
      }
    //if (newValue === null || newValue === "" ) this.lista_precio_d.precio_combo = parseFloat(0);
    },
  },
  computed: {
    inicio() {
      if (!this.current || !this.current.fecha_inicio) return null;
      return formatToISO(this.current.fecha_inicio);
    },
    fin() {
      if (!this.current || !this.current.fecha_fin) return null;
      return formatToISO(this.current.fecha_fin);
    },
    diaSiguiente() {
      const hoy = new Date();
      hoy.setDate(hoy.getDate() + 1);
      return hoy.toISOString().split('T')[0];
    },
    // La fecha fin no puede ser menor que la fecha inicio ni menor que hoy
    // Límite mínimo REAL para la fecha de inicio
    minFechaInicio() {
      if (!this.inicio) return this.diaSiguiente;
      // Si la fecha de inicio de current es menor o igual a hoy, 
      // se toma el día siguiente; de lo contrario, se respeta inicio.
      return this.inicio < this.diaSiguiente ? this.diaSiguiente : this.inicio;
    },
    // Límite mínimo para la fecha de fin
    minFechaFin() {
      return this.lista_precio_e.fecha_inicio || this.minFechaInicio;
    },
    // Límite mínimo para la fecha de fin del modal de modificación de fechas de la receta
    minFechaFinModificar() {
      if (this.modificarFecha.fecha_inicio && this.modificarFecha.fecha_inicio > this.diaSiguiente) {
        return this.modificarFecha.fecha_inicio;
      }
      return this.diaSiguiente;
    },
    // Límite mínimo para la fecha de fin del modal de edición de fecha de una lista de precio
    minFechaFinEditarListaPrecio() {
      return this.editarListaPrecioE.fecha_inicio || this.minFechaInicio;
    },
    // Límite mínimo para la fecha de fin del modal de duplicar receta
    minFechaFinDuplicar() {
      if (this.duplicarReceta.fecha_inicio && this.duplicarReceta.fecha_inicio > this.diaSiguiente) {
        return this.duplicarReceta.fecha_inicio;
      }
      return this.diaSiguiente;
    },
    detallesRecetaFiltrada() {
      // Si el campo de búsqueda está vacío, muestra todas las facturas
      if (!this.buscarDetalles) {
        return this.detallesReceta;
      }
      const lowerCaseSearch = this.buscarDetalles.toLowerCase();
      return this.detallesReceta.filter(detalle => {
        //Convertir en String los campos a filtrar
        const skuProducto = String(detalle.producto || "");
        const nombreProducto = String(detalle.producto_obj.nombre || "");
        const unidadMedida = String(detalle.unidad_medida_obj.nombre || "");
        // Convierte en minúsculas y realiza la búsqueda en el caso la cadena incluya alguno de los caracteres escritos en el campo de busqueda
        return (
          skuProducto.toLowerCase().includes(lowerCaseSearch) ||
          nombreProducto.toLowerCase().includes(lowerCaseSearch) ||
          unidadMedida.toLowerCase().includes(lowerCaseSearch)
        );
      });
    },
    computedMessage(){
      return this.currentStatus;
    },
    columnasPrecios() {
      const columnas = []
      this.current.recetaeprecio_set.forEach(precios => {
        columnas.push({ tipo: 'venta', lista_precio: precios.lista_precio, nombre: precios.lista_precio_obj.nombre });
        columnas.push({ tipo: 'descuento', lista_precio: precios.lista_precio, nombre: precios.lista_precio_obj.nombre });
        columnas.push({ tipo: 'combo', lista_precio: precios.lista_precio, nombre: precios.lista_precio_obj.nombre });
        columnas.push({ tipo: 'subtotal', lista_precio: precios.lista_precio, nombre: precios.lista_precio_obj.nombre });
      })
      return columnas;
    },
    sugeridoVenta(){
      if(this.lista_precio_d.ingrediente && this.lista_precio_d.lista_precio && this.lista_precio_d.ingrediente.precios_venta.length > 0){
        const precio = this.lista_precio_d.ingrediente.precios_venta.find(precio => precio.lista_precio === this.lista_precio_d.lista_precio)
        console.log("precio: ",precio);
        return precio? precio.precio:0;
      }
      return 0;
    },
    logsFiltrados() {
      if (!this.current || !this.current.recetalog_set) return [];

      return this.current.recetalog_set.filter(log => {
        // 1. Buscador texto (usuario_username y accion)
        const query = this.searchQuery.toLowerCase().trim();
        const matchUsuario = log.usuario_username ? log.usuario_username.toLowerCase().includes(query) : false;
        const matchAccion = log.accion ? log.accion.toLowerCase().includes(query) : false;
        const matchSearch = !query || matchUsuario || matchAccion;

        // 2. Filtro selector por tipo
        const matchTipo = !this.selectedTipo || log.tipo === this.selectedTipo;

        return matchSearch && matchTipo;
      });
    },
    // Extrae los tipos únicos de los logs para llenar el selector dinámicamente
    tiposDisponibles() {
      if (!this.current || !this.current.recetalog_set) return [];
      const tipos = this.current.recetalog_set.map(log => log.tipo).filter(Boolean);
      return [...new Set(tipos)]; // Retorna array sin duplicados
    },
    resumenTrazabilidad() {
      if (!this.current || !this.current.recetalog_set || !Array.isArray(this.current.recetalog_set)) {
        return [];
      }

      // 1. Mapeo de nombres de acción personalizados
      const mapaAcciones = {
        'solicitar_autorizacion': 'solicitado por',
        'cerrar': 'autorizado por',
        'reabrir': 'reabierta por',
        'anular': 'anulado por'
      };

      return this.current.recetalog_set
        // 2. Filtrar solo las acciones permitidas y con tipo EXITO
        .filter(log => log.accion && mapaAcciones.hasOwnProperty(log.accion) && log.tipo === 'EXITO')
        
        // 3. Crear una copia con .slice() y ordenar por fecha (del más actual / reciente al más viejo)
        .slice()
        .sort((a, b) => new Date(a.fecha_creacion) - new Date(b.fecha_creacion))
        
        // 4. Mapear al nuevo formato JSON requerido
        .map(log => ({
          username: log.usuario_username,
          fecha_creacion: this.obtenerFechaHora(log.fecha_creacion),
          accion: mapaAcciones[log.accion]
        }));
    }
  },

  mounted() {
    //this.encontrado = false;
    if (this.$route.params.id) {
      this.refreshCurrent();
    }
  },

  methods: {
    refreshCurrent() {
      RecetaService.getById(this.$route.params.id)
      .then(response => {
        this.current = response.data;
        this.detallesReceta = this.current.recetad_set;
        this.encontrado = true;
      })
      .catch(error => {
        this.encontrado = false;
        if (error.response) {
          this.errors = error.response.data;
          notificarError(this.$toast,error.response.data);
          this.regresar();
        }
      })
      
    },
    obtenerFechaHora(fecha){
      let fecha_hora = `${parsearFechaHoraString(fecha).fecha} ${parsearFechaHoraString(fecha).hora}`
      return fecha_hora
    },
    validarFechas() {
      const feInicio = this.lista_precio_e.fecha_inicio;
      const feFin = this.lista_precio_e.fecha_fin;

      // 1. Caso especial: Si el día siguiente sobrepasa la fecha fin de current,
      // significa que el rango ya expiró o no permite nuevas fechas.
      if (this.fin && this.minFechaInicio > this.fin) {
        this.lista_precio_e.fecha_inicio = null;
        this.lista_precio_e.fecha_fin = null;
        alert("No se pueden registrar fechas: la vigencia ha finalizado.");
        return;
      }

      // 2. Validar que fecha_inicio esté dentro de [minFechaInicio, fin]
      if (feInicio) {
        if (feInicio < this.minFechaInicio) {
          this.lista_precio_e.fecha_inicio = this.minFechaInicio;
        } else if (this.fin && feInicio > this.fin) {
          this.lista_precio_e.fecha_inicio = this.fin;
        }
      }

      // 3. Validar que fecha_fin no sea menor a la fecha_inicio seleccionada
      // ni mayor a la fecha_fin de current
      if (feFin) {
        const minFin = this.lista_precio_e.fecha_inicio || this.minFechaInicio;
        if (feFin < minFin) {
          this.lista_precio_e.fecha_fin = minFin;
        } else if (this.fin && feFin > this.fin) {
          this.lista_precio_e.fecha_fin = this.fin;
        }
      }
    },
    agregarDetalle() {
      this.guardando = true;
      this.detalle.producto = this.productoSeleccionado.sku;
      this.detalle.receta = this.current.id;
      if (this.detalle.cantidad_um < 0) this.detalle.cantidad_um * -1;
      this.guardando = false;
      RecetaService.postAction(this.current.id, 'agregar_detalle', this.detalle)
        .then(response => {
          this.guardando = false;
          notificarExito(this.$toast,response.data);
          this.limpiarProducto();
          this.refreshCurrent();
        })
        .catch(error => {
          this.guardando = false;
          if (error.response) {
            this.errors = error.response.data;
            notificarError(this.$toast,error.response.data);
          }
        })
    },
    limpiarProducto() {
      this.errors = null;
      this.productoSeleccionado = null;
      this.costoDeshabilitado = false;
      this.precioDeshabilitado = false;
      this.detalle = {
        producto: '',
        cantidad_um: 1,
        unidad_medida: "",
      };
      this.codigoBarras = '';
      this.errorBusqueda = '';

      this.$nextTick(() => {
        this.$refs.scannerInput.focus();
      });
    },
    evaluarProducto(unidad_medida) {
      if (this.productoSeleccionado == null) {
        return;
      }
      const recetaEncontrada = this.current.recetad_set.find(receta => receta.producto === this.productoSeleccionado.sku && receta.unidad_medida === unidad_medida)
      if (recetaEncontrada) {
        this.costoDeshabilitado = true;
        this.precioDeshabilitado = true;
      } else {
        this.costoDeshabilitado = false;
        this.precioDeshabilitado = false;
      }
    },
    agregarInventario() {
      this.inventario.receta = this.current.id;
      this.inventario.cantidad_fabricada = parseInt(this.inventario.cantidad_fabricada);
      RecetaService.postAction(this.current.id, 'agregar_inventario', this.inventario)
        .then(response => {
          notificarExito(this.$toast,response.data);
          this.refreshCurrent();
          this.limpiarInventario();
          $('#movimientoInventarioModal').modal('hide');
        })
        .catch(error=>{
          console.error(error.response.data);
          notificarError(this.$toast,error.response.data);
        })
    },
    quitarInventario() {
      this.inventario.receta = this.current.id;
      this.inventario.cantidad_desmantelada = parseInt(this.inventario.cantidad_desmantelada);
      RecetaService.postAction(this.current.id, 'quitar_inventario', this.inventario)
        .then(response => {
          notificarExito(this.$toast,response.data);
          this.refreshCurrent();
          this.limpiarInventario();
          $('#movimientoInventario2Modal').modal('hide');
        })
        .catch(error=>{
          console.error(error.response.data);
          notificarError(this.$toast,error.response.data);
        })
    },
    // ENCABEZADO
    agregarListaPrecioE(){
      let params = {
        lista_precio:this.lista_precio_e.lista_precio.id,
        fecha_inicio:this.lista_precio_e.fecha_inicio,
        fecha_fin:this.lista_precio_e.fecha_fin
      }
      RecetaService.agregarListaPrecioE(this.current.id,params)
      .then(response => {
        console.log(response.data);
        notificarExito(this.$toast,response.data);
        $('#agregarListaPrecioEModal').modal('hide');
        this.refreshCurrent();
      })
      .catch(error =>{
        console.error(error.response.data);
        notificarError(this.$toast,error.response.data);
      })
    },
    // DETALLE
    agregarListaPrecioD(){
      const ingrediente = this.lista_precio_d.ingrediente;
      let params = {
        lista_precio:this.lista_precio_d.lista_precio,
        producto:ingrediente.producto,
        precio_combo:this.lista_precio_d.precio_combo,
        receta_d:ingrediente.id
      }
      DynamicService.postAction("cat","receta-detalles",ingrediente.id,"agregar_precio_detalle",params)
      .then(response => {
        notificarExito(this.$toast,response.data);
        $('#agregarListaPrecioDModal').modal('hide');
        this.refreshCurrent();
      })
      .catch(error =>{
        console.error(error.response.data);
        notificarError(this.$toast,error.response.data);
      })
    },
    limpiarInventario() {
      this.inventario.receta = null;
      this.inventario.cantidad_fabricada = '';
      this.inventario.tienda = '';

    },
    quitarDetalle(detalle) {
      Notifications.alert.confirm(
        "Está a punto de remover el detalle de la receta",
        "¿Está seguro que desea continuar?",
        "Sí",
        () => {
          RecetaService.postAction(this.current.id,'quitar_detalle', {detalle_id:detalle.id})
          .then(response => {
            notificarExito(this.$toast,response.data);
            this.refreshCurrent();
            this.limpiarProducto();
          })
          .catch(error => {
            console.error(error.response.data);
            notificarError(this.$toast,error.response.data);
          })
        }
      );
    },
    cerrarReceta(){
      Notifications.alert.confirm(
        "Cerrar",
        "¿Está seguro que desea cerrar la receta?",
        "Sí",
        () => {
          RecetaService.postAction(this.current.id,'cerrar')
          .then(response => {
            notificarExito(this.$toast,response.data);
            this.refreshCurrent();
          })
          .catch(error => {
            console.error('Error al cerrar la receta:', error);
            if (error.response) {
              console.error(error.response.data)
              notificarError(this.$toast,error.response.data);
            }
          });
        }
      )
    },
    porcentajeDescuento(detalle, lista_precio){
      const item = detalle.recetadprecio_set.find(item => item.lista_precio === lista_precio);
      const resultado = item ? `% ${item.porcentaje_descuento.toFixed(4)}`: "Sin asignar";
      return resultado;
    },
    precioCosto(detalle, lista_precio){
      // No se utiliza
      const item = detalle.recetadprecio_set.find(item => item.lista_precio === lista_precio);
      const resultado = item ? `Q ${item.precio_costo}`: "Sin asignar";
      return resultado;
    },
    precioVenta(detalle, lista_precio){
      const item = detalle.recetadprecio_set.find(item => item.lista_precio === lista_precio);
      const resultado = item ? `Q ${item.precio_venta}`: "Sin asignar";
      return resultado;
    },
    precioCombo(detalle, lista_precio){
      const item = detalle.recetadprecio_set.find(item => item.lista_precio === lista_precio);
      const resultado = item ? `Q ${item.precio_combo}`: "Sin asignar";
      return resultado;
    },
    precioSubtotal(detalle, lista_precio){
      const item = detalle.recetadprecio_set.find(item => item.lista_precio === lista_precio);
      const resultado = item ? `Q ${item.subtotal.toFixed(2)}`: "Sin asignar";
      return resultado;
    },
    abrirModalListaPrecioD(ingrediente=null){
      $('#agregarListaPrecioDModal').modal('show');
      this.limpiarModalListaPrecioD();
      if(ingrediente!=null){this.lista_precio_d.ingrediente=ingrediente};
    },
    abrirModalListaPrecioE(){
      $('#agregarListaPrecioEModal').modal('show');
      this.limpiarModalListaPrecioE();
    },
    limpiarModalListaPrecioE(){
      this.lista_precio_e.lista_precio=null,
      this.lista_precio_e.fecha_inicio=null,
      this.lista_precio_e.fecha_fin=null
    },
    abrirModalEditarFechaListaPrecio(precioe){
      this.editarListaPrecioE = {
        id: precioe.id,
        nombre: precioe.lista_precio_obj ? precioe.lista_precio_obj.nombre : '',
        fecha_inicio: formatToISO(precioe.fecha_inicio),
        fecha_fin: formatToISO(precioe.fecha_fin),
      };
      $('#editarFechaListaPrecioModal').modal('show');
    },
    validarFechasEditarListaPrecio() {
      const feInicio = this.editarListaPrecioE.fecha_inicio;
      const feFin = this.editarListaPrecioE.fecha_fin;

      // Si el día siguiente sobrepasa la fecha fin de current, la vigencia ya expiró
      if (this.fin && this.minFechaInicio > this.fin) {
        this.editarListaPrecioE.fecha_inicio = null;
        this.editarListaPrecioE.fecha_fin = null;
        alert("No se pueden registrar fechas: la vigencia ha finalizado.");
        return;
      }

      // Validar que fecha_inicio esté dentro de [minFechaInicio, fin]
      if (feInicio) {
        if (feInicio < this.minFechaInicio) {
          this.editarListaPrecioE.fecha_inicio = this.minFechaInicio;
        } else if (this.fin && feInicio > this.fin) {
          this.editarListaPrecioE.fecha_inicio = this.fin;
        }
      }

      // Validar que fecha_fin no sea menor a la fecha_inicio seleccionada ni mayor a la fecha_fin de current
      if (feFin) {
        const minFin = this.editarListaPrecioE.fecha_inicio || this.minFechaInicio;
        if (feFin < minFin) {
          this.editarListaPrecioE.fecha_fin = minFin;
        } else if (this.fin && feFin > this.fin) {
          this.editarListaPrecioE.fecha_fin = this.fin;
        }
      }
    },
    guardarEditarFechaListaPrecio(){
      let params = {
        fecha_inicio: this.editarListaPrecioE.fecha_inicio,
        fecha_fin: this.editarListaPrecioE.fecha_fin,
        receta_precio_id: this.editarListaPrecioE.id,
      };
      RecetaService.modificarFechaListaPrecio(this.current.id, params)
      .then(response => {
        notificarExito(this.$toast,response.data);
        $('#editarFechaListaPrecioModal').modal('hide');
        this.refreshCurrent();
      })
      .catch(error => {
        console.error(error.response.data);
        notificarError(this.$toast,error.response.data);
      })
    },
    abrirModalModificarFecha(){
      const inicioActual = this.inicio;
      this.modificarFecha.fecha_inicio = (inicioActual && inicioActual > this.diaSiguiente) ? inicioActual : this.diaSiguiente;
      const finActual = this.fin;
      this.modificarFecha.fecha_fin = (finActual && finActual >= this.modificarFecha.fecha_inicio) ? finActual : this.modificarFecha.fecha_inicio;
    },
    validarFechasModificar() {
      if (this.modificarFecha.fecha_inicio < this.diaSiguiente) {
        this.modificarFecha.fecha_inicio = this.diaSiguiente;
      }
      if (this.modificarFecha.fecha_fin && this.modificarFecha.fecha_fin < this.minFechaFinModificar) {
        this.modificarFecha.fecha_fin = this.minFechaFinModificar;
      }
    },
    guardarModificarFecha(){
      let params = {
        fecha_inicio: this.modificarFecha.fecha_inicio,
        fecha_fin: this.modificarFecha.fecha_fin,
      };
      RecetaService.modificarFechaReceta(this.current.id, params)
      .then(response => {
        notificarExito(this.$toast,response.data);
        $('#modalModificarFechaReceta').modal('hide');
        this.refreshCurrent();
      })
      .catch(error => {
        console.error(error.response.data);
        notificarError(this.$toast,error.response.data);
      })
    },
    limpiarModalListaPrecioD(){
      this.lista_precio_d.ingrediente=null;
      this.lista_precio_d.lista_precio=null;
      this.lista_precio_d.precio_combo=0.00;
      this.lista_precio_d.precio_cero=false;
    },
    abrirModalDuplicar(){
      this.duplicarReceta = {
        fecha_inicio: null,
        fecha_fin: null,
      };
    },
    validarFechasDuplicar() {
      if (this.duplicarReceta.fecha_inicio < this.diaSiguiente) {
        this.duplicarReceta.fecha_inicio = this.diaSiguiente;
      }
      if (this.duplicarReceta.fecha_fin && this.duplicarReceta.fecha_fin < this.minFechaFinDuplicar) {
        this.duplicarReceta.fecha_fin = this.minFechaFinDuplicar;
      }
    },
    guardarDuplicar() {
      let params = {
        fecha_inicio: this.duplicarReceta.fecha_inicio,
        fecha_fin: this.duplicarReceta.fecha_fin,
      };
      this.currentStatus = 'Duplicando receta...';
      RecetaService.postAction(this.current.id,'duplicar', params)
      .then(response => {
        this.currentStatus = '';
        notificarExito(this.$toast,response.data);
        $('#productoCloneModal').modal('hide');
        const nuevaRecetaId = response.data.id;
        console.log(nuevaRecetaId)
        Notifications.alert.confirm(
          "Duplicar",
          "¿Desea ir a la receta duplicada?",
          "Sí",
          () => {
            this.$router.push({
              name: 'cat-receta-editar',
              params: { id: nuevaRecetaId }
            })
          }
        )
      })
      .catch(error => {
        this.currentStatus = '';
        console.error('Error al duplicar la receta:', error);
        if (error.response) {
          console.error(error.response.data)
          notificarError(this.$toast,error.response.data);
        }
      });
    },
    reabrir(){
      Notifications.alert.prompt(
        "Reabrir",
        "Por favor indique el motivo de reapertura.",
        "Escribe el motivo",
        (motivo) => {
          let params={
            'motivo':motivo
          }
          RecetaService.reabrir(this.current.id,params)
          .then(response => {
            notificarExito(this.$toast,response.data);
            this.refreshCurrent();
          })
          .catch(error => {
            console.error('Error al cerrar la receta:', error);
            if (error.response) {
              console.error(error.response.data);
              notificarError(this.$toast,error.response.data);
              this.refreshCurrent();
            }
          });
        }
      )
    },
    // 1. Prepara el input al hacer clic en 'Editar'
    iniciarEdicion(index, detalle) {
      this.indiceEditando = index;
      this.cantidadTemporal = detalle.cantidad_um; // Carga el valor actual en el modelo temporal
    },
    
    // 2. Guarda el cambio y recalcula al hacer clic en 'Guardar'
    guardarCantidad(detalle) {
      const nuevaCantidad = parseFloat(this.cantidadTemporal);

      // Validación
      if (isNaN(nuevaCantidad) || nuevaCantidad <= 0) {
        notificarAdvertencia(this.$toast,"Debes ingresar valores numéricos positivos en Cantidad");
        return;
    }

      // Actualiza el arreglo principal
      let params = {
        'cantidad_um':nuevaCantidad
      };
      DynamicService.postAction("cat","receta-detalles", detalle.id,"actualizar_cantidad",params)
      .then(response => {
        notificarExito(this.$toast,response.data);
        this.refreshCurrent();
      })
      .catch(error => {
          console.error('Error al actualizar la cantidad:', error);
          notificarError(this.$toast,error.response.data);
        });

      // Resetea el estado de edición
      this.indiceEditando = null;
      this.cantidadTemporal = null;
      
    },
    solicitarAutorizacion(){
      let params = {}
      Notifications.alert.confirm(
        "Solicitar Autorización",
        "Una vez esté pendiente no se podrán realizar cambios, ¿Desea continuar?",
        "Sí",
        () => {
          RecetaService.solicitarAutorizacion(this.current.id,params)
          .then(response => {
            notificarExito(this.$toast,response.data);
            this.refreshCurrent();
          })
          .catch(error => {
            console.error(error.response.data);
            notificarError(this.$toast,error.response.data);
          })
      })
    },
    regresar() {
      this.$router.push({ name: 'cat-recetas' });
    },
    manejarError(mensaje) {
      this.errorBusqueda = mensaje;
      // Opcional: limpiar el error después de un tiempo
      setTimeout(() => {
        this.errorBusqueda = null;
      }, 5000);
    },
    imprimirRecetario(lista_precio){
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let Id = String(this.current.id).replace(/-/g, '');
      let Lista = parseInt(lista_precio)
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/receta/Recetario.jrxml&Id=${Id}&Lista=${Lista}`,
      );
    },
  }
};
</script>

<style scoped>
/* Estilos mínimos adicionales */
.vr {
  width: 2px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.1);
}

/* Contenedor (opcional, para centrar o agrupar) */
.switch-container {
  display: inline-block;
}

/* 1. Ocultar el checkbox nativo */
.switch-checkbox {
  height: 0;
  width: 0;
  visibility: hidden;
}

/* 2. Estilo del fondo del interruptor (la pista) */
.switch-label {
  cursor: pointer;
  text-indent: -9999px;
  /* Oculta el texto de la etiqueta si lo hubiera */
  width: 60px;
  /* Ancho total del interruptor */
  height: 34px;
  /* Altura total del interruptor */
  background: #ccc;
  /* Gris claro cuando está apagado */
  display: block;
  border-radius: 34px;
  /* Hace los bordes redondos */
  position: relative;
  transition: background-color 0.3s;
  /* Animación de cambio de color */
}

/* 3. Estilo del botón deslizable (el pulgar) */
.switch-label:after {
  content: '';
  position: absolute;
  top: 3px;
  /* Espaciado interno */
  left: 3px;
  /* Espaciado interno */
  width: 28px;
  /* Tamaño del círculo */
  height: 28px;
  background: #fff;
  /* Color del círculo */
  border-radius: 90px;
  transition: 0.3s;
  /* Animación de deslizamiento */
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  /* Sombra sutil */
}

/* 4. Cuando el checkbox está CHEQUEADO: */
/* Cambia el color del fondo */
.switch-checkbox:checked+.switch-label {
  background: #4CAF50;
  /* Un verde bonito cuando está encendido */
}

/* Mueve el botón deslizable hacia la derecha */
.switch-checkbox:checked+.switch-label:after {
  left: calc(100% - 3px);
  /* Mueve el botón al final */
  transform: translateX(-100%);
  /* Ajuste fino para centrar */
}

/* CÓDIGO PARA PEGAR EN TU <style> */
.status-message {
    display: inline-block; /* NECESARIO para que la animación de 'transform' funcione */
    font-size: 0.95em;
    color: #007bff;
    font-weight: bold;
    min-height: 1.2em; /* Mantiene la altura para evitar que otros elementos salten */
}

/* ---------------------------------------------------- */
/* CLASES DE TRANSICIÓN VUE */
/* ---------------------------------------------------- */

/* Estado inicial al entrar y estado final al salir */
.message-slide-enter, .message-slide-leave-to {
    opacity: 0;
    transform: translateY(-5px); /* Desplazamiento vertical para el efecto "salto" */
}

/* Transición activa (define la velocidad) */
.message-slide-enter-active, .message-slide-leave-active {
    transition: all 0.3s ease-in-out;
}
.action-hover:hover{
  background-color: rgb(0, 200, 10);
  color:white !important;
}
</style>